import { Typography } from '@execonline-inc/execonline-ui';
import { assertNever } from '@kofno/piper';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T, TPlainTextKey } from '../../../../../Translations';
import { participantSearchStore } from './Stores/ParticipantSearchStore';

type Tab = 'participants' | 'groups';

const TABS: ReadonlyArray<Tab> = ['participants', 'groups'];

const tabLabel = (tab: Tab): TPlainTextKey => {
  switch (tab) {
    case 'participants':
      return 'Participants';
    case 'groups':
      return 'Groups';
    default:
      return assertNever(tab);
  }
};

// Same underline tab pattern as the license alerts' AccessTabs on this screen.
const TabNavigation: React.FC = () => {
  return (
    <div className="border-b border-border px-8" data-intercom-target="participant-search-tabs">
      <div className="flex gap-8">
        {TABS.map((tab) => {
          const active = participantSearchStore.activeTab === tab;
          return (
            <button
              key={tab}
              type="button"
              aria-selected={active}
              className={clsx(
                'pb-3 pt-6 border-b-2 transition-colors',
                active
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )}
              onClick={() => participantSearchStore.setActiveTab(tab)}
              data-intercom-target={`participant-search-tab-${tab}`}
            >
              <Typography
                variant="bodyMedium"
                as="span"
                fontWeight={active ? 'semibold' : 'normal'}
              >
                <T kind={tabLabel(tab)} />
              </Typography>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default observer(TabNavigation);
